import { Breakpoints } from '../constants';

export default function getWindowBreakpoint() {
    if (typeof window === 'undefined') {
        return Breakpoints.xxsmall;
    }

    const windowWidth = window.innerWidth;

    if (windowWidth >= Breakpoints.xxlarge) {
        return Breakpoints.xxlarge;
    } else if (windowWidth >= Breakpoints.xlarge) {
        return Breakpoints.xlarge;
    } else if (windowWidth >= Breakpoints.large) {
        return Breakpoints.large;
    } else if (windowWidth >= Breakpoints.medium) {
        return Breakpoints.medium;
    } else if (windowWidth >= Breakpoints.small) {
        return Breakpoints.small;
    } else if (windowWidth >= Breakpoints.xsmall) {
        return Breakpoints.xsmall;
    }
    return Breakpoints.xxsmall;
}
